/*
 * @Author: mayanxia 
 * @Date: 2020-08-28 16:49:15 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2024-02-02 16:12:29
 */

<template>
    <div class="index-container">
        <a-spin :spinning="false" style="height: 100%">
            <div style="height: 165px;width: 100%;position: fixed;top: 0;left: 0" class="header-row-line"></div>
            <a-row style="height: 78px" :gutter="3" class="header-row">
                <a-col :span="24" style="height: 100%">
                    <a-row style="height: 100%" :gutter="3" class="header">
                        <a-col :span="9">
                            <div style="height: 100%;" class="header-left">
                                <div class="tabs">
                                    <div class="tab" v-for="item in tabList" :key="item.key" :class="tabKey == item.key?'tab-active': ''" @click="tabKey = item.key">
                                        <label class="tab-title" >{{item.title}}</label>
                                    </div>
                                </div>
                            </div>
                        </a-col>
                        <a-col :span="6" style="height: 100%;text-align: center;padding-top:14px" class="theme-color theme-font flex-center">{{ $t('智慧水务管理平台') }}</a-col>
                        <a-col :span="9" style="text-align: right">
                            <div style="height: 100%;justify-content: flex-end;" class=" flex-center header-right">
                                <!-- <div class="right-time flex" style="margin-right: 8px;">
                                    <div class="time" style="line-height: 1">{{time}}</div>
                                    <div class="date" style="line-height: 1">{{date}}</div>
                                </div> -->
                                <shortcut-menu @refresh="refreshPage"></shortcut-menu>
                            </div>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
            <a-row style="height: calc(100% - 78px)">
                <a-col style="height: 100%">
                    <screen-waterQuality ref="screenPart" v-if="tabKey == 'tabKey1'"></screen-waterQuality>
                    <screen-business ref="screenPart" v-else-if="tabKey == 'tabKey2'"></screen-business>
                    <screen-workOrder ref="screenPart" v-else-if="tabKey == 'tabKey3'"></screen-workOrder>
                    <screen-inspection ref="screenPart" v-else-if="tabKey == 'tabKey4'"></screen-inspection>
                    <screen-meterReading ref="screenPart" v-else-if="tabKey == 'tabKey5'"></screen-meterReading>
                </a-col>
            </a-row>
        </a-spin>
    </div>
</template>
<script>
// import echarts from 'echarts/lib/echarts';
import screenBusiness from './screen-business';
import screenWaterQuality from './screen-waterQuality'
import screenWorkOrder from './screen-workOrder'
import screenInspection from './screen-inspection'
import screenMeterReading from './screen-meterReading'

import shortcutMenu from './modules/shortcutMenu'

import { formatTime } from "@/utils/util"

export default {
  components: { screenBusiness,screenWaterQuality,shortcutMenu,screenWorkOrder,screenInspection,screenMeterReading },
    name: "screen",
    data() {
        return {
            timer: null,// 定时器
            loading: true,
            config: {
            data: [99]
            },
            option1: {},
            tabKey: 'tabKey1',
            time: '',
            date: ''
        }
    },
    computed: {
        // i18n：页签标题使用 computed 以响应语言切换
        tabList() {
            return [
              {title: this.$t('供水分析'), key: 'tabKey1'},
              {title: this.$t('运营分析'), key: 'tabKey2'},
              {title: this.$t('工单管理'), key: 'tabKey3'},
              {title: this.$t('巡检管理'), key: 'tabKey4'},
              {title: this.$t('抄表管理'), key: 'tabKey5'},
            ]
        }
    },
    created() {
        
    },
    mounted() {
        this.$nextTick(() => {
            this.timer = setInterval(this.setDateTime,1000)
        })
    },
    methods: {
        setDateTime() {
            let time = formatTime(new Date().getTime(),'yyyy年MM月dd日 HH:mm:ss')
            let dateArr = time.split(' ')
            this.date = dateArr[0]
            this.time = dateArr[1]
        },
        refreshPage() {
            this.$refs.screenPart.init()
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
    }
}
</script>
<style scoped>
.index-container{
    height: 100vh;
    background: url('~@/assets/images/bg.png') #08092D repeat;
    overflow: hidden;
}
.echarts {
    height: 100%;
}
.theme-color{
    color: #ffffff;
}
.theme-color.theme-font{
    font-size: 30px;
    letter-spacing: -0.18px;
}
.header-row-line{
    background-image: linear-gradient(0deg, rgba(0,4,57,0.00) 0%, #00053A 100%);
}
.header{
    background: url('~@/assets/images/header.png') #000439 no-repeat;
    background-size: 100% 100%;
}
.ant-spin-nested-loading /deep/ .ant-spin-container{
    height: 100%
}
.tabs{
    display: flex;
    margin-left: 21px;
}
.tab{
    padding: 18px 16px 10px 16px;
    margin: 0 15px 0 0;
    
    cursor: pointer;
}
.tab-active{
    position: relative;
}
.tab:last-child {

    margin-right: 0;
}
.tab-title{
    font-size: 18px;
    font-weight: 700;
    color: #6CB2ED;
    cursor: pointer;
}
.tab-active{
    color: #ffffff;
    position: relative;
    background:linear-gradient(to bottom, rgba(17,96,165,0), rgba(0,143,255,0.92));
    background-clip: border-box;
}
.tab-active .tab-title{
    color: #C7E5FF;
}
.tab-active::before{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #209DFF;
    transition: all .3s;

}
.header-right{
    margin-right: 27px;
    padding: 24px 10px 10px 16px; 
}
.right-time{
    color: #96CFFF;
    font-size: 22px;
}
.right-time .time{
    padding-right: 16px;
    color: #ffffff;
}
.tab:last-child{
  position: absolute;
  z-index: 99;
  top: 0;
  right: -113%;
}
</style>